import(/* webpackMode: "eager" */ "/opt/mtp/MTP/components/providers/client-app.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientOnly"] */ "/opt/mtp/MTP/components/providers/client-only.tsx");
;
import(/* webpackMode: "eager" */ "/opt/mtp/MTP/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/mtp/MTP/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/opt/mtp/MTP/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/opt/mtp/MTP/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/opt/mtp/MTP/app/globals.css");
